module.exports = __webpack_public_path__ + "static/media/legal_document.bac49562.svg";